module.exports = __webpack_public_path__ + "img/AddChartOutlined.695cb02c.svg";